import "./AppEmployeeRecordPTORequests.css";
import { TimeOffRequest, PaidTimeOffPolicy, formatDateDayMonDDYYYY } from "winslow-core";

type AppEmployeeRecordPTORequestsProps = {
    timeOffRequests: TimeOffRequest[] | undefined;
    paidTimeOffPolicies: PaidTimeOffPolicy[] | undefined;
};

export const AppEmployeeRecordPTORequests = ({ 
    timeOffRequests, 
    paidTimeOffPolicies 
}: AppEmployeeRecordPTORequestsProps) => {
    if (!timeOffRequests || timeOffRequests.length < 1) {
        return (
            <div className="app-employee-record-pto-requests-empty">
                No time off requests
            </div>
        );
    }

    if (!paidTimeOffPolicies) {
        return (
            <div className="app-employee-record-pto-requests-empty">
                Loading policies...
            </div>
        );
    }

    return (
        <div className="app-employee-record-pto-requests">
            {timeOffRequests.map((request: TimeOffRequest) => {
                const policy = paidTimeOffPolicies.find((policy: PaidTimeOffPolicy) => {
                    return policy.id === request.paidTimeOffPolicyId;
                });

                if (!policy) {
                    return null;
                }

                return (
                    <div key={request.id} className="app-employee-record-pto-request">
                        <div className="app-employee-record-pto-request-policy">
                            <strong>Policy:</strong> {policy.name}
                        </div>
                        <div className="app-employee-record-pto-request-dates">
                            <div className="app-employee-record-pto-request-date">
                                <strong>Start Date:</strong> {formatDateDayMonDDYYYY(new Date(request.startDate))}
                            </div>
                            <div className="app-employee-record-pto-request-date">
                                <strong>End Date:</strong> {formatDateDayMonDDYYYY(new Date(request.endDate))}
                            </div>
                        </div>
                        <div className="app-employee-record-pto-request-status">
                            <strong>Status:</strong> {request.status}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

